(() => {
  'use strict';
  const script = document.currentScript;
  const catalogUrl = script?.dataset.catalog;
  if (!catalogUrl) return;
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const knownRoots = new WeakSet();
  const knownInputs = new WeakSet();
  const preloaded = new Set();
  let catalogPromise;
  let sequence = 0;
  const loadCatalog = () => catalogPromise ||= fetch(catalogUrl, { credentials: 'same-origin' })
    .then((response) => { if (!response.ok) throw new Error('Team catalog unavailable'); return response.json(); })
    .then((teams) => teams.map((team) => ({ ...team, terms: [team.name, ...team.aliases].map(normalize) })))
    .catch(() => []);

  const styles = `
    :host([data-pd-welcome-quiet]) section[data-sizing="form-wrapper"][aria-modal="true"], :host([data-pd-welcome-quiet]) [class*="_overlayBackground_"], :host([data-pd-welcome-quiet]) section[class*="_overlay_"] { display: none !important; }
    .pd-team-field{position:relative!important;min-width:0}
    .pd-team-field>input{padding-right:38px!important}
    .pd-team-indicator{position:absolute;right:16px;top:50%;width:8px;height:8px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:translateY(-70%) rotate(45deg);pointer-events:none;opacity:.55}
    .pd-team-results{position:absolute;left:0;right:0;top:calc(100% + 5px);z-index:2147483646;margin:0;padding:5px;background:#fff;color:#111;border:1px solid #dedede;border-radius:8px;box-shadow:0 8px 24px #0002;overflow:auto;overscroll-behavior:contain;max-height:220px;text-align:left;font:14px/1.3 Arial,sans-serif}
    .pd-team-results[hidden]{display:none!important}
    .pd-team-results[data-above]{top:auto;bottom:calc(100% + 5px)}
    .pd-team-option{display:flex!important;align-items:center;gap:10px;box-sizing:border-box!important;width:100%!important;min-height:42px!important;padding:8px 10px!important;margin:0!important;border:0!important;border-radius:4px!important;background:#fff!important;color:#111!important;text-align:left!important;font:14px/1.3 Arial,sans-serif!important;cursor:pointer!important;box-shadow:none!important;text-transform:none!important;letter-spacing:normal!important}
    .pd-team-option:hover,.pd-team-option[aria-selected=true]{background:#f7eeee!important;color:#bc1117!important}
    .pd-team-option img{flex:0 0 24px;width:24px!important;height:24px!important;max-width:24px!important;object-fit:contain!important}
    .pd-team-empty{padding:12px;font:13px/1.4 Arial,sans-serif;color:#666}
    .pd-team-status{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip-path:inset(50%);white-space:nowrap}
    .phone-country-selector{flex:0 0 64px!important;width:64px!important;min-width:64px!important}
    .phone-country-selector>div,.phone-country-selector button{width:100%!important;min-width:0!important}
    .phone-country-selector button{padding-left:10px!important;padding-right:10px!important;gap:8px!important}
    .phone-country-selector button>span:first-child{width:auto!important;flex:0 1 auto!important}
    .phone-country-selector button>span:last-child{display:flex!important;align-items:center!important;flex:0 0 8px!important;margin:0!important}
    .phone-country-selector img{width:22px!important;height:16px!important;object-fit:contain!important}
    [class*="_formPhoneInputContainer_"]>div:not(.phone-country-selector){flex:1 1 0!important;min-width:0!important}
    .pd-welcome-panel{animation:pd-welcome-in .32s cubic-bezier(.22,1,.36,1) both!important}
    .pd-welcome-backdrop{animation:pd-welcome-backdrop-in .28s ease both}
    .pd-welcome-decline{display:block!important;width:100%!important;min-height:40px!important;margin:6px 0 0!important;padding:8px!important;border:0!important;background:transparent!important;box-shadow:none!important;color:#595959!important;font:12px/1.4 Arial,sans-serif!important;letter-spacing:normal!important;text-transform:none!important;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
    .pd-welcome-decline:hover{color:#111!important}
    .pd-welcome-done{display:block;width:100%;min-height:46px;margin:18px 0 0;padding:12px 16px;border:0;border-radius:0;background:#d71014;color:#fff;font:800 13px/1.2 Arial,sans-serif;letter-spacing:.04em;text-transform:uppercase;cursor:pointer}
    .pd-welcome-done:hover{background:#b90e12}
    .pd-welcome-done:focus-visible{outline:2px solid #111;outline-offset:2px}
    .pd-welcome-panel [aria-label="Close modal"]{opacity:1!important;visibility:visible!important;z-index:3}
    .pd-welcome-decline:focus-visible{outline:2px solid #d71014!important;outline-offset:2px}
    .pd-welcome-title{display:flex!important;align-items:center!important;justify-content:center!important;gap:10px!important}
    .pd-welcome-title img{display:block!important;width:32px!important;height:42px!important;object-fit:contain!important;flex:0 0 32px!important}
    .pd-welcome-subtitle{display:none!important}
    form:has(.pd-welcome-decline){row-gap:10px!important}
    .pd-welcome-decline{min-height:32px!important;margin:-2px 0 0!important;padding:5px!important}
    :host([data-pd-welcome]) #app-embed[data-current-step="tease"]{left:0!important;right:auto!important;top:50%!important;bottom:auto!important;transform:translateY(-50%)!important;rotate:0deg!important;padding:0!important;width:auto!important;max-width:76px!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"]{box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;width:76px!important;min-width:0!important;height:54px!important;padding:8px!important;gap:0!important;border:0!important;border-radius:0 7px 7px 0!important;background:#d71014!important;color:#fff!important;box-shadow:0 3px 14px #0002!important;transition:background .2s ease!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"]:hover{background:#b90e12!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"] h3{margin:0!important;width:48px!important;font:700 11px/1.3 Arial,sans-serif!important;letter-spacing:.02em!important;text-align:center!important;text-transform:uppercase!important;white-space:normal!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"] [aria-label="Close modal"]{display:none!important}
    :host([data-pd-welcome]) #app-embed[data-current-step="tease"]{display:none!important}
    :host([data-pd-welcome]) #app-embed[data-current-step="tease"]{max-width:100px!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"]{position:relative!important;width:94px!important;height:68px!important;padding:12px 18px 12px 10px!important;border-radius:0!important;clip-path:polygon(0 0,82% 0,100% 50%,82% 100%,0 100%);background:linear-gradient(135deg,#b80913,#ed2029)!important;filter:drop-shadow(0 3px 5px #0003);box-shadow:none!important;transition:filter .2s ease,background .2s ease!important}
    :host([data-pd-welcome]) [data-testid="form-teaser"]::before{content:'✦';position:absolute;left:8px;top:6px;color:#fff9;font-size:10px}
    :host([data-pd-welcome]) [data-testid="form-teaser"]::after{content:'';position:absolute;right:13px;top:calc(50% - 3px);width:6px;height:6px;border-radius:50%;background:#fff;box-shadow:inset 0 1px 2px #0003}
    :host([data-pd-welcome]) [data-testid="form-teaser"] h3{width:58px!important;color:#fff!important;font:800 12px/1.15 Arial,sans-serif!important;letter-spacing:.035em!important}
    @keyframes pd-welcome-in{from{opacity:0;transform:translateY(18px) scale(.975)}to{opacity:1;transform:translateY(0) scale(1)}}
    @keyframes pd-welcome-backdrop-in{from{opacity:0}to{opacity:1}}
    @media(max-width:749px){
      :host([data-pd-welcome]) #app-embed[data-current-step="tease"]{left:-8px!important;max-width:72px!important}
      :host([data-pd-welcome]) [data-testid="form-teaser"]{width:72px!important;height:48px!important;padding:8px 12px 8px 10px!important}
      :host([data-pd-welcome]) [data-testid="form-teaser"] h3{width:46px!important;font-size:10px!important;letter-spacing:0!important}
      :host([data-pd-welcome]) [data-testid="form-teaser"]::before{display:none!important}
      :host([data-pd-welcome]) [data-testid="form-teaser"]::after{right:9px!important;width:4px!important;height:4px!important;top:calc(50% - 2px)!important}
      .pd-welcome-panel{grid-template-columns:minmax(0,1fr)!important;grid-template-rows:auto auto!important;max-height:calc(100dvh - 28px)!important;overflow:auto!important}
      .pd-welcome-panel>.pd-welcome-art{display:block!important;visibility:visible!important;width:100%!important;height:auto!important;min-height:0!important;aspect-ratio:2/1!important;background-image:url("https://cdn.shopify.com/s/files/1/0687/3995/6912/files/pd-popup-envio-gratis.webp?v=1793292760")!important;background-size:contain!important;background-repeat:no-repeat!important;background-position:center!important}
      .pd-welcome-panel>.pd-welcome-content{padding:20px 24px!important}
      .pd-welcome-panel [class*="_formContainerCloseButtonPosition_"]{top:10px!important;right:10px!important;z-index:2}
      /* En iPhone un campo con letra menor a 16px hace zoom a toda la página al tocarlo. */
      [class*="_formInputField_"],[class*="_formPhoneInputField_"],.pd-team-field>input{font-size:16px!important}
    }
    @media(max-width:480px){.pd-team-results{max-height:184px}.pd-team-option{min-height:42px!important}}
    @media(prefers-reduced-motion:reduce){.pd-welcome-panel,.pd-welcome-backdrop{animation:none!important}}
    section.pd-team-open,section.pd-welcome-panel.pd-team-open,[class*="_formContainer_"].pd-team-open{overflow:visible!important}
  `;

  // Quien se suscribe en el popup recibe el envío gratis ya aplicado: no tiene que escribir nada en el checkout.
  const shippingCode = 'ENVIOGRATIS';
  const shippingKey = 'pd-free-shipping-code';
  const applyShippingCode = () => {
    fetch('/discount/' + shippingCode, { credentials: 'same-origin', redirect: 'manual' }).catch(() => {});
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: shippingCode }) })
      .then((response) => response.json())
      .then((cart) => { document.dispatchEvent(new CustomEvent('pd-free-shipping:applied', { detail: cart })); return cart; })
      .catch(() => {});
  };
  // Si el carrito perdió el código (p. ej. se creó uno nuevo), se vuelve a poner al cargar la página.
  try {
    if (localStorage.getItem(shippingKey)) {
      fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json()).then((cart) => {
        const codes = (cart.discount_codes || []).map((entry) => String(entry.code).toUpperCase());
        if (cart.item_count && !codes.includes(shippingCode)) applyShippingCode();
      }).catch(() => {});
    }
  } catch (error) {}

  function welcomeExperience(host, root) {
    if (!/^app-embed-container-(1217955|1218406)$/.test(host.id)) return () => {};
    host.dataset.pdWelcome = '';
    const panels = new WeakSet();
    let closing = false;
    let nativeClose = false;
    // El popup se muestra una sola vez y no vuelve en 7 días; luego solo se abre si el cliente toca el aviso.
    const visitKey = 'pd-welcome-shown-at';
    const quietFor = 7 * 24 * 60 * 60 * 1000;
    let shownEarlier = false;
    try { shownEarlier = Date.now() - Number(localStorage.getItem(visitKey) || 0) < quietFor; } catch (error) {}
    let autoOpened = shownEarlier;
    let userOpened = false;
    // Forms abre el formulario apenas carga; se mantiene oculto hasta los 5 s.
    let holding = false;
    const reveal = () => { holding = false; delete host.dataset.pdWelcomeQuiet; document.documentElement.classList.toggle('pd-welcome-is-open', Boolean(getPanel())); };
    const rememberShown = () => { try { localStorage.setItem(visitKey, String(Date.now())); } catch (error) {} };
    if (shownEarlier) host.dataset.pdWelcomeQuiet = '';
    let submitted = false;
    let codeApplied = false;
    const markSubmitted = () => { submitted = true; };
    root.addEventListener('submit', markSubmitted, true);
    root.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('form button[type="submit"]')) markSubmitted();
    }, true);
    root.addEventListener('click', (event) => {
      if (event.isTrusted && event.target instanceof Element && event.target.closest('[data-testid="form-teaser"]')) {
        userOpened = true;
        delete host.dataset.pdWelcomeQuiet;
      }
    }, true);
    // Se cuenta desde que empezó a cargar la página, no desde que llegó Forms (que tarda varios segundos).
    const readyAt = performance.timeOrigin + 5000;
    const autoOpen = () => {
      if (autoOpened || !host.isConnected) return;
      if (holding) { autoOpened = true; rememberShown(); reveal(); return; }
      if (getPanel()?.getClientRects().length) { autoOpened = true; rememberShown(); return; }
      const teaser = root.querySelector('[data-testid="form-teaser"]');
      if (!teaser) return;
      autoOpened = true;
      rememberShown();
      teaser.click();
    };
    setTimeout(autoOpen, Math.max(0, readyAt - Date.now()));
    const openFromTab = () => {
      userOpened = true;
      if (holding) { reveal(); return; }
      delete host.dataset.pdWelcomeQuiet;
      root.querySelector('[data-testid="form-teaser"]')?.click();
    };
    document.addEventListener('pd-welcome:open', openFromTab);
    const getPanel = () => root.querySelector('section[data-sizing="form-wrapper"][aria-modal="true"]');
    const close = () => {
      const panel = getPanel();
      const closeButton = panel?.querySelector('[aria-label="Close modal"]');
      if (!panel || closing) return;
      const finish = () => {
        nativeClose = true;
        // En el mensaje de éxito Forms a veces no dibuja la X: entonces el popup se oculta desde el theme.
        if (closeButton?.isConnected) closeButton.click();
        else { host.dataset.pdWelcomeQuiet = ''; document.documentElement.classList.remove('pd-welcome-is-open'); }
        nativeClose = false;
        closing = false;
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
      closing = true;
      const options = { duration: 210, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' };
      const motion = panel.animate([{ opacity: 1, transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: 'translateY(12px) scale(.98)' }], options);
      root.querySelector('.pd-welcome-backdrop')?.animate([{ opacity: 1 }, { opacity: 0 }], options);
      motion.finished.catch(() => {}).then(finish);
    };
    root.addEventListener('click', (event) => {
      if (nativeClose || !getPanel()) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('[aria-label="Close modal"], [class*="_overlayBackground_"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !host.isConnected || !getPanel()?.getClientRects().length || root.querySelector('[role="combobox"][aria-expanded="true"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    }, true);
    return () => {
      const teaser = root.querySelector('[data-testid="form-teaser"]');
      if (!autoOpened && Date.now() >= readyAt) autoOpen();
      const teaserHeading = teaser?.querySelector('h3');
      if (teaserHeading && teaserHeading.textContent !== 'Envío gratis') teaserHeading.textContent = 'Envío gratis';
      if (teaser && teaser.getAttribute('aria-label') !== 'Envío gratis') teaser.setAttribute('aria-label', 'Envío gratis');
      const panel = getPanel();
      document.documentElement.classList.toggle('pd-welcome-is-open', Boolean(panel?.getClientRects().length) && !host.hasAttribute('data-pd-welcome-quiet'));
      if (!panel) return;
      if (shownEarlier && !userOpened) {
        const dismiss = panel.querySelector('[aria-label="Close modal"]');
        if (dismiss && !nativeClose) { nativeClose = true; dismiss.click(); nativeClose = false; }
        return;
      }
      if (!userOpened && !autoOpened && Date.now() < readyAt) { holding = true; host.dataset.pdWelcomeQuiet = ''; }
      else { autoOpened = true; rememberShown(); }
      if (!panels.has(panel)) {
        panels.add(panel);
        panel.classList.add('pd-welcome-panel');
        panel.querySelector('[class*="_gridItemContent_"]')?.classList.add('pd-welcome-content');
        root.querySelector('[class*="_overlayBackground_"]')?.classList.add('pd-welcome-backdrop');
      }
      const content = panel.querySelector('[class*="_gridItemContent_"]');
      const title = content?.querySelector('h2');
      if (title && title.textContent.trim() === 'ENVÍO GRATIS') {
        title.classList.add('pd-welcome-title');
        const brand = document.querySelector('.pd-header__logo img, .pd-header__brand img, .pd-header img');
        if (brand && !title.querySelector('img')) {
          const logo = document.createElement('img');
          logo.src = brand.currentSrc || brand.src;
          logo.alt = 'Primera División';
          title.prepend(logo);
        }
      }
      content?.querySelectorAll('p').forEach((paragraph) => {
        if (paragraph.textContent.trim() === 'en tu primera compra. Colombia e internacional.') paragraph.classList.add('pd-welcome-subtitle');
      });
      let artwork = panel.querySelector('.pd-welcome-art');
      if (!artwork) {
        artwork = [...panel.children].find((child) => child !== content && child.className.includes('_gridItem_'));
        if (artwork) artwork.classList.add('pd-welcome-art');
      }
      if (!artwork && content && matchMedia('(max-width:749px)').matches) {
        artwork = document.createElement('div');
        artwork.className = 'pd-welcome-art';
        artwork.setAttribute('role', 'img');
        artwork.setAttribute('aria-label', 'Envío gratis en tu primera compra');
        panel.prepend(artwork);
      }
      const form = panel.querySelector('form');
      const submit = form?.querySelector('button[type="submit"]');
      if (submit && !form.querySelector('.pd-welcome-decline')) {
        const decline = document.createElement('button');
        decline.type = 'button';
        decline.className = 'pd-welcome-decline';
        decline.textContent = 'Prefiero pagar el envío';
        decline.addEventListener('click', close);
        submit.after(decline);
      }
      if (!form) panel.querySelector('.pd-welcome-decline')?.remove();
      // Solo en el mensaje de éxito (tras enviar), nunca mientras el formulario aún se está dibujando.
      if (!form && content && (submitted || /activado/i.test(title?.textContent || '')) && !content.querySelector('.pd-welcome-done')) {
        const done = document.createElement('button');
        done.type = 'button';
        done.className = 'pd-welcome-done';
        done.textContent = 'Seguir comprando';
        done.addEventListener('click', close);
        content.append(done);
      }
      // Tras enviar, Forms cambia el formulario por el mensaje de éxito: ahí se aplica el código.
      if (submitted && !form && !codeApplied) {
        codeApplied = true;
        try { localStorage.setItem(shippingKey, String(Date.now())); } catch (error) {}
        applyShippingCode();
      }
    };
  }

  function enhance(input, root) {
    if (knownInputs.has(input)) return;
    knownInputs.add(input);
    const wrapper = input.parentElement;
    if (!wrapper) return;
    wrapper.classList.add('pd-team-field');
    const id = `pd-team-options-${++sequence}`;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    const list = document.createElement('div');
    list.id = id;
    list.className = 'pd-team-results';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Equipos y selecciones');
    list.hidden = true;
    const indicator = document.createElement('span');
    indicator.className = 'pd-team-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    const status = document.createElement('span');
    status.className = 'pd-team-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    wrapper.append(indicator, list, status);
    let matches = [];
    let active = -1;
    let request = 0;
    let frame = 0;
    let chosenAt = 0;
    let blurTimer = 0;
    // En celular el popup tiene scroll propio y el teclado tapa la parte de abajo:
    // mientras la lista está abierta, el popup no la recorta y la lista se recoloca cuando aparece el teclado.
    const clipper = () => wrapper.closest('.pd-welcome-panel, [class*="_formContainer_"]');
    const place = () => {
      const rect = wrapper.getBoundingClientRect();
      const viewport = window.visualViewport;
      const viewportTop = viewport ? viewport.offsetTop : 0;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const below = viewportBottom - rect.bottom - 12;
      const above = rect.top - viewportTop - 12;
      const useAbove = below < 200 && above > below;
      list.toggleAttribute('data-above', useAbove);
      list.style.maxHeight = `${Math.max(84, Math.min(220, useAbove ? above : below))}px`;
    };
    const follow = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { if (!list.hidden) place(); });
    };
    const track = (on) => {
      const method = on ? 'addEventListener' : 'removeEventListener';
      window.visualViewport?.[method]('resize', follow);
      window.visualViewport?.[method]('scroll', follow);
      window[method]('resize', follow);
      clipper()?.classList.toggle('pd-team-open', on);
    };
    const close = () => {
      request++;
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
      track(false);
    };
    const setValue = (value) => {
      const view = input.ownerDocument.defaultView;
      Object.getOwnPropertyDescriptor(view.HTMLInputElement.prototype, 'value').set.call(input, value);
      input.dispatchEvent(new view.Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new view.Event('change', { bubbles: true, composed: true }));
    };
    // Un toque en celular puede llegar como "touchend" y luego como "click": se elige una sola vez
    // y se cierra el teclado en vez de volver a enfocar el campo (eso reabría la lista).
    const choose = (team, touch) => {
      if (Date.now() - chosenAt < 450) return;
      chosenAt = Date.now();
      clearTimeout(blurTimer);
      setValue(team.name);
      close();
      if (touch) input.blur(); else input.focus();
    };

    // Los escudos se descargan apenas aparece el campo, para que ya estén listos al abrir la lista.
    loadCatalog().then((teams) => teams.forEach((team) => {
      if (!team.image || preloaded.has(team.image)) return;
      preloaded.add(team.image);
      const image = new Image();
      image.decoding = 'async';
      image.src = team.image;
    }));
    function highlight(index) {
      active = index;
      Array.from(list.children).forEach((option, position) => option.setAttribute('aria-selected', String(position === active)));
      const option = list.children[active];
      if (option) {
        input.setAttribute('aria-activedescendant', option.id);
        option.scrollIntoView({ block: 'nearest' });
      }
    }
    async function show() {
      if (Date.now() - chosenAt < 450) return;
      const ticket = ++request;
      const teams = await loadCatalog();
      if (ticket !== request || root.activeElement !== input || !input.isConnected || !teams.length) return;
      const query = normalize(input.value);
      const tokens = query.split(' ').filter(Boolean);
      matches = teams.filter((team) => !query || tokens.every((token) => team.terms.some((term) => term.includes(token))))
        .sort((a, b) => Number(b.terms.some((term) => term.startsWith(query))) - Number(a.terms.some((term) => term.startsWith(query))) || a.name.localeCompare(b.name, 'es'));
      list.replaceChildren();
      active = -1;
      input.removeAttribute('aria-activedescendant');
      // Show a scrollable complete list, including every matching team.
      matches.forEach((team, index) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.tabIndex = -1;
        option.id = `${id}-${index}`;
        option.className = 'pd-team-option';
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        if (team.image) {
          const image = document.createElement('img');
          image.src = team.image;
          image.alt = '';
          image.width = 24;
          image.height = 24;
          image.loading = 'eager';
          image.decoding = 'async';
          image.addEventListener('error', () => image.remove(), { once: true });
          option.append(image);
        }
        const label = document.createElement('span');
        label.textContent = team.name;
        option.append(label);
        let tap = null;
        option.addEventListener('pointerdown', (event) => { if (event.pointerType === 'mouse') event.preventDefault(); });
        option.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          tap = { x: touch.clientX, y: touch.clientY };
        }, { passive: true });
        option.addEventListener('touchmove', (event) => {
          const touch = event.changedTouches[0];
          if (tap && (Math.abs(touch.clientX - tap.x) > 10 || Math.abs(touch.clientY - tap.y) > 10)) tap = null;
        }, { passive: true });
        option.addEventListener('touchcancel', () => { tap = null; });
        option.addEventListener('touchend', (event) => {
          if (!tap) return;
          tap = null;
          event.preventDefault();
          choose(team, true);
        });
        option.addEventListener('click', () => choose(team, false));
        list.append(option);
      });
      if (!matches.length) {
        const empty = document.createElement('div');
        empty.className = 'pd-team-empty';
        empty.textContent = 'Sin coincidencias. Puedes escribir el nombre de tu equipo.';
        list.append(empty);
      }
      place();
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      track(true);
      // El teclado del celular termina de abrir después del foco; se recoloca cuando ya está arriba.
      setTimeout(follow, 350);
      setTimeout(follow, 800);
      status.textContent = `${matches.length} ${matches.length === 1 ? 'equipo disponible' : 'equipos disponibles'}`;
    }
    input.addEventListener('focus', show);
    input.addEventListener('click', show);
    input.addEventListener('input', show);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !list.hidden) {
        event.preventDefault();
        event.stopPropagation();
        close();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (list.hidden) { show(); return; }
        if (matches.length) highlight(active < 0 ? (event.key === 'ArrowDown' ? 0 : matches.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length);
      } else if (event.key === 'Enter' && !list.hidden && active >= 0) {
        event.preventDefault();
        choose(matches[active]);
      } else if (event.key === 'Tab') close();
    });
    input.addEventListener('blur', () => {
      clearTimeout(blurTimer);
      blurTimer = setTimeout(() => { if (input.getRootNode().activeElement !== input) close(); }, 200);
      loadCatalog().then((teams) => {
        if (!input.isConnected || root.activeElement === input) return;
        const query = normalize(input.value);
        const exact = teams.find((team) => team.terms.includes(query));
        if (exact && exact.name !== input.value) setValue(exact.name);
      });
    });
  }

  function connect(host) {
    const root = host.shadowRoot;
    if (!root || knownRoots.has(root)) return;
    knownRoots.add(root);
    const style = document.createElement('style');
    style.dataset.pdTeamSearch = 'true';
    style.textContent = styles;
    root.append(style);
    const scanWelcome = welcomeExperience(host, root);
    const scan = () => {
      root.querySelectorAll('input[id="custom#equipo_favorito"]').forEach((input) => enhance(input, root));
      scanWelcome();
    };
    scan();
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
  }
  const scanHosts = () => document.querySelectorAll('shopify-forms-embed').forEach(connect);
  scanHosts();
  customElements.whenDefined('shopify-forms-embed').then(scanHosts);
  new MutationObserver(scanHosts).observe(document.body, { childList: true, subtree: true });
})();
